import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { AuthService } from '@core/services/auth.service';
import { NotificationService } from '@core/services/notification.service';
import { ACCESS_TOKEN_COOKIE } from '@core/auth.constants';


@Component({
  selector: 'app-token',
  imports: [CardModule, ButtonModule, InputTextModule],
  templateUrl: './token.html',
  styleUrl: './token.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TokenComponent implements OnInit {
  accessToken: string = '';

  constructor(
    private authService: AuthService,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.loadAccessToken();
  }

  private loadAccessToken() {
    // Получаем access_token напрямую из cookie
    const token = this.getCookie(ACCESS_TOKEN_COOKIE);
    this.accessToken = token || 'Token not found';
  }

  private getCookie(name: string): string | null {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) {
        return decodeURIComponent(c.substring(nameEQ.length, c.length));
      }
    }
    return null;
  }

  async copyToken() {
    try {
      await navigator.clipboard.writeText(this.accessToken);
      this.notificationService.showSuccess('Text is Copied');
    } catch (err) {
      // Fallback для старых браузеров
      const textArea = document.createElement('textarea');
      textArea.value = this.accessToken;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      
      this.notificationService.showSuccess('Text is Copied');
    }
  }
}